<template>
  <footer class="py-4" :style="{ backgroundImage: 'url(' + require(`@/assets/footer.jpg`) + ')' }">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-white">2026 MGB & Events - QReventos.com - Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>